import { render, staticRenderFns } from "./PersonAddOutlined.vue?vue&type=template&id=f1dd4290&"
import script from "./PersonAddOutlined.vue?vue&type=script&lang=js&"
export * from "./PersonAddOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports